import { REQUEST } from 'Stores'
import {
  CHANGE_PASSWORD,
  LOGIN,
  LOGIN_GOOGLE_SSO,
  LOGIN_MS_SSO,
  LOGOUT,
  PAYMENT_REGISTER,
  REGISTER_BASIC,
  REGISTER_BASIC_INVITE,
  REGISTER_ENTERPRISE,
  REGISTER_GOOGLE_SSO,
  REGISTER_RESEND_EMAIL,
  RESET_PASSWORD_SEND_MAIL,
  SIGN_UP_VERIFY_TOKEN
} from './constants'

export function registerGoogleSSO(payload) {
  return {
    type: REQUEST(REGISTER_GOOGLE_SSO),
    payload
  }
}

export function registerBasic(payload) {
  return {
    type: REQUEST(REGISTER_BASIC),
    payload
  }
}

export function registerBasicInvite(payload) {
  return {
    type: REQUEST(REGISTER_BASIC_INVITE),
    payload
  }
}

export function registerWithPayment(payload) {
  return {
    type: REQUEST(PAYMENT_REGISTER),
    payload
  }
}

export function registerReSendEmail(payload) {
  return {
    type: REQUEST(REGISTER_RESEND_EMAIL),
    payload
  }
}

export function login(payload) {
  return {
    type: REQUEST(LOGIN),
    payload
  }
}

export function loginGoogleSSO(payload) {
  return {
    type: REQUEST(LOGIN_GOOGLE_SSO),
    payload
  }
}

export function loginMSSSO(payload) {
  return {
    type: REQUEST(LOGIN_MS_SSO),
    payload
  }
}

export function resetPasswordSendMail(payload) {
  return {
    type: REQUEST(RESET_PASSWORD_SEND_MAIL),
    payload
  }
}

export function changePassword(payload) {
  return {
    type: REQUEST(CHANGE_PASSWORD),
    payload
  }
}

export function registerEnterprise(payload) {
  return {
    type: REQUEST(REGISTER_ENTERPRISE),
    payload
  }
}

export function signUpVerifyToken(payload) {
  return {
    type: REQUEST(SIGN_UP_VERIFY_TOKEN),
    payload
  }
}

export function logOut(payload) {
  return {
    type: REQUEST(LOGOUT),
    payload
  }
}
